import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import SectionWrapper from '@/components/atoms/SectionWrapper';
import { LogisticsFeedbackFilters } from '@/components/LogisticsFeedback/LogisticsFeedbackFilters';
import { LogisticsFeedbackTable } from '@/components/LogisticsFeedback/LogisticsFeedbackTable';
import { FeedbackFilterModal } from '@/components/LogisticsFeedback/FeedbackFilterModal';
import { FeedbackDetailsDrawer } from '@/components/LogisticsFeedback/Drawer/FeedbackDetailsDrawer';
import {
  LOGISTICS_FEEDBACK_PAGE_SIZE,
  LOGISTICS_FEEDBACK_SEARCH_KEY,
  useLogisticsFeedback,
} from '@/hooks/useLogisticsFeedback';
import { setPage, setSearch } from '@/store/slices/publicSlice';

export default function LogisticsFeedbackPage() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);

  const {
    filters,
    activeFiltersCount,
    paginatedList,
    totalElements,
    currentPage,
    isLoading,
    isFetching,
    isDetailLoading,
    selectedFeedbackItem,
    hasNext,
    hasPrev,
    selectFeedback,
    closeDrawer,
    handleNext,
    handlePrev,
    handleApplyFilters,
    handlePageChange,
  } = useLogisticsFeedback();

  useEffect(() => {
    return () => {
      dispatch(setSearch({ key: LOGISTICS_FEEDBACK_SEARCH_KEY, value: '' }));
      dispatch(setPage(0));
    };
  }, [dispatch]);

  return (
    <SectionWrapper
      title={t('logisticsFeedback.pageTitle')}
      desc={t('logisticsFeedback.pageDesc')}
      whiteBgChildren
      data-testid="logistics-feedback-page"
    >
      <div className="space-y-6" data-testid="logistics-feedback-container">
        <LogisticsFeedbackFilters
          onFilterClick={() => setIsFilterModalOpen(true)}
        />

        <LogisticsFeedbackTable
          data={paginatedList}
          currentPage={currentPage}
          pageSize={LOGISTICS_FEEDBACK_PAGE_SIZE}
          totalElements={totalElements}
          loading={isLoading || isFetching}
          onPageChange={handlePageChange}
          onSelectFeedback={(item) => selectFeedback(item.id)}
          data-testid="logistics-feedback-table-wrapper"
        />
      </div>

      <FeedbackFilterModal
        isOpen={isFilterModalOpen}
        onClose={() => setIsFilterModalOpen(false)}
        filters={filters}
        onApplyFilters={handleApplyFilters}
        data-testid="logistics-feedback-filter-modal-instance"
      />

      <FeedbackDetailsDrawer
        open={Boolean(selectedFeedbackItem)}
        onClose={closeDrawer}
        feedbackItem={selectedFeedbackItem}
        loading={isDetailLoading}
        onNext={handleNext}
        onPrev={handlePrev}
        hasNext={hasNext}
        hasPrev={hasPrev}
        data-testid="logistics-feedback-details-drawer"
      />
    </SectionWrapper>
  );
}
